var map = {
	"./admin-events/admin-events.module": [
		"../../../../../src/app/admin-events/admin-events.module.ts",
		"common",
		"admin-events.module"
	],
	"./admin-org/admin-org.module": [
		"../../../../../src/app/admin-org/admin-org.module.ts",
		"common",
		"admin-org.module"
	],
	"./allevents/allevents.module": [
		"../../../../../src/app/allevents/allevents.module.ts",
		"common",
		"allevents.module"
	],
	"./contacts/contacts.module": [
		"../../../../../src/app/contacts/contacts.module.ts",
		"common",
		"contacts.module"
	],
	"./dashboard/dashboard.module": [
		"../../../../../src/app/dashboard/dashboard.module.ts",
		"common",
		"dashboard.module"
	],
	"./event-details/event-details.module": [
		"../../../../../src/app/event-details/event-details.module.ts",
		"common",
		"event-details.module"
	],
	"./events/events.module": [
		"../../../../../src/app/events/events.module.ts",
		"common",
		"events.module"
	],
	"./events2/events.module": [
		"../../../../../src/app/events2/events.module.ts",
		"common",
		"events.module.0"
	],
	"./feedback/feedback.module": [
		"../../../../../src/app/feedback/feedback.module.ts",
		"common",
		"feedback.module"
	],
	"./materials/materials.module": [
		"../../../../../src/app/materials/materials.module.ts",
		"common",
		"materials.module"
	],
	"./news/news.module": [
		"../../../../../src/app/news/news.module.ts",
		"common",
		"news.module"
	],
	"./participants/participant.module": [
		"../../../../../src/app/participants/participant.module.ts",
		"common",
		"participant.module"
	],
	"./programs/program.module": [
		"../../../../../src/app/programs/program.module.ts",
		"common",
		"program.module"
	],
	"./pub2/pub2.module": [
		"../../../../../src/app/pub2/pub2.module.ts",
		"common",
		"pub2.module"
	],
	"./social-wall/social-wall.module": [
		"../../../../../src/app/social-wall/social-wall.module.ts",
		"common",
		"social-wall.module"
	],
	"./speakers/speaker.module": [
		"../../../../../src/app/speakers/speaker.module.ts",
		"common",
		"speaker.module"
	],
	"./sponsers/sponsers.module": [
		"../../../../../src/app/sponsers/sponsers.module.ts",
		"common",
		"sponsers.module"
	],
	"./twitter/twitter.module": [
		"../../../../../src/app/twitter/twitter.module.ts",
		"common",
		"twitter.module"
	],
	"./upgrade/upgrade.module": [
		"../../../../../src/app/upgrade/upgrade.module.ts",
		"common",
		"upgrade.module"
	],
	"./user-authentication/user-authentication.modules": [
		"../../../../../src/app/user-authentication/user-authentication.modules.ts",
		"user-authentication.modules"
	],
	"./user-management/user-management.module": [
		"../../../../../src/app/user-management/user-management.module.ts",
		"common",
		"user-management.module"
	],
	"./webview/webview.module": [
		"../../../../../src/app/webview/webview.module.ts",
		"webview.module"
	],
	"./whitelabel/whitelabel.module": [
		"../../../../../src/app/whitelabel/whitelabel.module.ts",
		"common",
		"whitelabel.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// C:/Users/neenu.korula/AA/eventorg-web/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main